import * as Dialog from '@radix-ui/react-dialog';
import { twMerge } from 'tailwind-merge';

export type ContentProps = Dialog.DialogContentProps;

export function Content({ className, ...props }: ContentProps) {
  return (
    <Dialog.Content
      {...props}
      className={twMerge(
        'fixed top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2',
        'max-h-[calc(100vh-7.5rem)] max-w-3xl md:w-auto',
        'overflow-hidden bg-white md:rounded-xl',
        'flex flex-col',
        className,
      )}
    />
  );
}
